export default {
	"nav.upgrade.button": "Upgrade",

	"nav.user.dropdown.billing": "Billing",
	"nav.user.dropdown.team": "Team Settings",
	"nav.user.dropdown.account": "Account Settings",
	"nav.user.dropdown.referrals": "Referrals",
	"nav.user.dropdown.logout": "Log out",
}
